import React from 'react';

import { CollapsibleContent } from './collapsible-content';

export type NewsItemProps = React.HTMLAttributes<HTMLDivElement>;

export function NewsItem({
  children,
  ...props
}: React.PropsWithChildren<NewsItemProps>) {
  return (
    <div {...props} className="flex gap-x-3">
      {children}
    </div>
  );
}

export function NewsItemBody({ children }: React.PropsWithChildren<object>) {
  return <div className="flex flex-col gap-2">{children}</div>;
}

export function NewsItemIcon({ children }: React.PropsWithChildren<object>) {
  return (
    <div className="size-5 flex-none" aria-hidden="true">
      <span className="skeleton">{children}</span>
    </div>
  );
}

export function NewsItemDescription({
  isCollapsible = true,
  children,
}: React.PropsWithChildren<{ isCollapsible?: boolean }>) {
  if (isCollapsible) {
    <CollapsibleContent>{children}</CollapsibleContent>;
  }
  return <div className="skeleton">{children}</div>;
}

export function NewsItemThumbnail({
  thumbnail,
}: {
  thumbnail:
    | {
        src: string;
        alt: string;
        href: string;
      }
    | undefined;
}) {
  if (!thumbnail) {
    return null;
  }

  return (
    <a
      href={thumbnail.href}
      target="_blank"
      rel="noreferrer"
      className="block max-w-56 cursor-pointer overflow-hidden rounded-lg border border-gray-200 hover:shadow"
    >
      <div className="aspect-video w-full">
        <img
          src={thumbnail.src}
          alt={thumbnail.alt}
          className="size-full object-cover"
        />
      </div>
      <div className="truncate bg-white px-2 py-1 text-gray-400">
        <span className="text-xs">{thumbnail.href}</span>
      </div>
    </a>
  );
}
